'use client';

import { useEffect, useRef, useState } from 'react';
// You don't need to import this one to use it, only import useAlert to inject msg
import { ConAlertMolecule } from '@gandalf/babylon/molecules/alert';
import { useAlertToast } from '@frodo/lib/hooks';
import { Translations } from '@frodo/models/types';
import { PageType } from '@frodo/models/enums';
import cls from './index.module.scss';

export type AlertToastType = {
  trans: Translations;
  pageType: PageType;
};
export const AlertToast = ({ trans, pageType }: AlertToastType) => {
  const alerts = useAlertToast(state => state.alerts);
  const [hide, setHide] = useState<Record<string, boolean>>({});
  const alertTimeouts = useRef<Record<string, string>>({});

  useEffect(() => {
    alerts.forEach(({ id }) => {
      if (!alertTimeouts.current[id]) {
        setHide(state => ({
          ...state,
          [id]: false,
        }));
        setTimeout(() => {
          setHide(state => ({
            ...state,
            [id]: true,
          }));
        }, 5000);
        alertTimeouts.current[id] = id;
      }
    });
  }, [alerts]);

  return (
    <div className={`${cls.container} ${cls[pageType] ?? ''}`}>
      {alerts.map(({ type, text, id }) => (
        <ConAlertMolecule
          key={id}
          ariaLabel={trans['aria-label.close-overlay']}
          hideCallback={() => {
            setHide(state => ({
              ...state,
              [id]: true,
            }));
          }}
          hide={!!hide[id]}
          overlay={false}
          type={type}
          cls={cls.alertItem}
          text={text}
          dataQA="alert-msg"
        />
      ))}
    </div>
  );
};
